import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultLayoutComponent } from './containers';
import { AdslInquiryComponent } from './views/sales/adsl-inquiry/adsl-inquiry.component';
import { AdslRoundupComponent } from './views/sales/adsl-roundup/adsl-roundup.component';
import { TdlteOnlineComponent } from './views/sales/tdlte-online/tdlte-online.component';
import { ExpiredComponent } from './views/shared/expired/expired.component';
import { LoginComponent } from './views/shared/login/login.component';
import { PayComponent } from './views/shared/pay/pay.component';
import { PayallComponent } from './views/shared/payall/payall.component';
import { IssueFormComponent } from './views/home/issue-form/issue-form.component';
import { FibermapComponent } from './views/sales/fibermap/fibermap.component';
import { WirelessmapComponent } from './views/sales/wirelessmap/wirelessmap.component';
import { DedicateLocationComponent } from './views/sales/dedicate-location/dedicate-location.component';
import { DedicatePreinvoiceComponent } from './views/sales/dedicate-preinvoice/dedicate-preinvoice.component';

export const routes: Routes = [
  {
    path: 'pay/:id',
    component: PayComponent,
    data: { title: 'PAY' }
  },
  {
    path: 'payall/:account',
    component: PayallComponent,
    data: { title: 'PAY' }
  },
  {
    path: 'p/:account',
    component: PayallComponent,
    data: { title: 'PAY' }
  },
  {
    path: 'expired',
    component: ExpiredComponent,
    data: { title: 'EXPIRED' }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'LOGIN' }
  },
  {
    path: 'adsl',
    component: AdslInquiryComponent,
    data: { title: 'ADSL' }
  },
  {
    path: 'adsl-roundup',
    component: AdslRoundupComponent,
    data: { title: 'ADSL' }
  },
  {
    path: 'tdlte-online',
    component: TdlteOnlineComponent,
    data: { title: 'TDLTE' }
  },
  {
    path: 'fiber-map',
    component: FibermapComponent,
    data: { title: 'FIBER_MAP', public: true }
  },
  {
    path: 'wireless-map',
    component: WirelessmapComponent,
    data: { title: 'WIRELESS_MAP', public: true }
  },
  {
    path: 'dedicate-location',
    component: DedicateLocationComponent,
    data: { title: 'DEDICATE_LOCATION', public: true }
  },
  {
    path: 'dedicate-location/:token',
    component: DedicateLocationComponent,
    data: { title: 'DEDICATE_LOCATION', public: true }
  },
  {
    path: 'dedicate-preinvoice/:token',
    component: DedicatePreinvoiceComponent,
    data: { title: 'DEDICATE_PREINVOICE', public: true }
  },
  {
    path: 'resume',
    component: IssueFormComponent,
    data: { department: 'office', type: 'resume' }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    loadChildren: () => import('./views/home/home.module').then(m => m.HomeModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
